import React from 'react'
import BadgeUI from '../../../widgets/output/BadgeUI'
import SearchUI from '../../../widgets/input/SearchUI'
import LRTableBodyUI from '../../../widgets/layout/LRTableBodyUI'
import LRTableRowUI from '../../../widgets/layout/LRTableRowUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import LabelAndValueUI from '../../../widgets/layout/LabelAndValueUI'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import './VendorBillList.css'

const VendorBillListUI = ({ context, messageList, billList,
  searchFilter, onRefreshClick, onSearchFilterChange, onCreateClick
}) =>
  <div className='vnd_bls g_m_top_100'>

    <LRTableActionsUI location='top'
      left={
        <ActionLeftUI
          context={context}
          messageList={messageList}
          onRefreshClick={onRefreshClick}
          onCreateClick={onCreateClick}
        />
      }
      right={
        <ActionTopRightUI
          context={context}
          messageList={messageList}
          searchFilter={searchFilter}
          onSearchFilterChange={onSearchFilterChange}
        />
      }
    />

    <LRTableBodyUI className='data_tbl'>
      {
        billList.map((bill, i) =>
          <BillRowUI key={i} context={context} messageList={messageList} bill={bill} />
        )
      }
    </LRTableBodyUI>
  </div>

const BillRowUI = ({ context, bill, messageList }) =>
  <LRTableRowUI
    context={context}
    left={<RowLeftUI context={context} messageList={messageList} bill={bill} />}
    right={<RowRightUI context={context} messageList={messageList} bill={bill} />}
    className='g_flex_top'
  />

const RowLeftUI = ({ context, messageList, bill }) =>
  <div className='g_flex_v'>
    <span className='g_small g_muted'>{bill.billDateF1}</span>
    <span><b>{bill.billName}</b></span>
    <span>{bill.vendorName}</span>
    <span className='g_muted'>TDS {bill.tdsSection} {bill.tdsNature}
      {bill.tdsRate ? ` @${bill.tdsRate}` : ` @0`}%
    </span>
    <span className='g_muted'>Debit A/C no {bill.debitAccountNumber}</span>
    {
      bill.vendorDocumentRef &&
      <>
        <span className='g_small g_muted'>Vendor document ref</span>
        <span>{bill.vendorDocumentRef}</span>
      </>
    }
    {
      bill.itemSpec &&
      <>
      <span className='g_small g_muted'>Item spec</span>
      <span>{bill.itemSpec}</span>
      </>
    }
    <span className='g_muted'>{bill.notes}</span>
    <span className='g_small g_muted'>Due {bill.dueDateF1}</span>
  </div>

const RowRightUI = ({ context, messageList, bill }) =>
  <div className='g_text_right'>
    <BadgeUI messageList={messageList} label={bill.status} />
    <div className='g_small g_muted'>{bill.paidDateF1}</div>

    <table><tbody>
      <tr><td>Amount</td><td className='g_text_right'>{bill.subTotalF2}</td></tr>
      {
        bill.taxList.map((tax, j) =>
          <tr key={j}>
            <td className='g_no_wrap_2'>{tax.name}</td>
            <td className='g_text_right'>{tax.amountF2}</td>
          </tr>
        )
      }
      <tr><td>Total</td><td className='g_text_right'>{bill.billAmountF2}</td></tr>
      <tr><td>TDS {bill.tdsRate ? ` @${bill.tdsRate}` : ` @0`}%</td>
        <td className='g_text_right'>{bill.tdsAmountF2}</td></tr>
      <tr><td>Pending</td><td className='g_text_right'>{bill.pendingAmountF2}</td></tr>
    </tbody></table>
  </div>

const ActionLeftUI = ({ context, messageList, onRefreshClick, onCreateClick
}) =>
  <div className='g_flex_h'>
    <IconButtonUI messageList={messageList} icon='icon-refresh' onClick={onRefreshClick} labelKey='c_refresh' />
    {/*
      context.permissions && context.permissions.includes('acc_manage') &&
      <IconButtonUI messageList={messageList} icon='icon-plus' onClick={onCreateClick} labelKey='c_create_invoice' />
    */}
  </div>

const ActionTopRightUI = ({ context, messageList, searchFilter, onSearchFilterChange
}) =>
  <div className='g_flex_h'>
    <SearchUI value={searchFilter} onChange={onSearchFilterChange} />
  </div>

export default VendorBillListUI
